import { AbstractControl, Validator } from '@angular/forms';
//Got from: https://scotch.io/tutorials/how-to-implement-a-custom-validator-directive-confirm-password-in-angular-2
var EqualValidator = /** @class */ (function () {
    function EqualValidator(validateEqual, reverse) {
        this.validateEqual = validateEqual;
        this.reverse = reverse;
    }
    Object.defineProperty(EqualValidator.prototype, "isReverse", {
        get: function () {
            if (!this.reverse) {
                return false;
            }
            return this.reverse === 'true';
        },
        enumerable: true,
        configurable: true
    });
    EqualValidator.prototype.validate = function (control) {
        var pairControl = control.root.get(this.validateEqual);
        if (!pairControl) {
            return null;
        }
        var value = control.value;
        var pairValue = pairControl.value;
        if (!value && !pairValue) {
            return null;
        }
        if (this.isReverse) {
            if (value === pairValue) {
                if (pairControl.errors) {
                    delete pairControl.errors['validateEqual'];
                }
                if (!Object.keys(pairControl.errors).length) {
                    pairControl.setErrors(null);
                }
            }
            else {
                pairControl.setErrors({
                    validateEqual: true
                });
            }
            return null;
        }
        else {
            if (value !== pairValue) {
                return {
                    validateEqual: true
                };
            }
        }
    };
    return EqualValidator;
}());
export { EqualValidator };
